const initialState = {
  groupedWishlistBySkuId: {},
  allSelected: false,
  redirectCart: false,
  loadingAddListCart: false,
  length: 0,
  leastOneSelected: false,
  loading: false
}

const getRedirectCart = state => {
  for (var i in state.groupedWishlistBySkuId) {
    if (state.groupedWishlistBySkuId[i].loadingAddCart) return false
  }
  return true
}

const getVerifySelected = state => {
  state.leastOneSelected = false
  state.allSelected = true

  for (var i in state.groupedWishlistBySkuId) {
    if (state.groupedWishlistBySkuId[i].selected) state.leastOneSelected = true
    else state.allSelected = false
  }
  return true
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_WISHLIST': {
      return { ...state, loading: true }
    }
    case 'FETCH_WISHLIST_SUCCESS': {
      var wishlist =
        state && state.wishlist
          ? [...state.wishlist, ...action.payload.data]
          : [...action.payload.data]

      var groupWishlist = {}

      if (wishlist) {
        var length = 0
        wishlist.map((item, index) => {
          length++
          item.loading = false
          item.removed = false
          item.selected = false
          groupWishlist[item.skuId] = item
        })
      }
      return {
        groupedWishlistBySkuId: groupWishlist,
        length: length,
        loading: false
      }
    }
    case 'FETCH_WISHLIST_FAIL': {
      return {
        groupedWishlistBySkuId: null,
        error:
          action.request && action.request.status !== 404 ? 'Error' : undefined,
        loading: false
      }
    }
    case 'ADD_WISHLIST': {
      var itemAdd = state.groupedWishlistBySkuId[action.skuId]
      if (!itemAdd) {
        itemAdd = { skuId: action.skuId }
        state.groupedWishlistBySkuId[action.skuId] = itemAdd
      }

      itemAdd.loading = true
      itemAdd.removed = false
      itemAdd.selected = false
      state.loadingAddListCart = true
      return { ...state }
    }
    case 'ADD_WISHLIST_SUCCESS': {
      var skuIdAddSuccess =
        action.meta &&
        action.meta.previousAction &&
        action.meta.previousAction.skuId
      if (action.payload.data === true) {
        var itemAdded = state.groupedWishlistBySkuId[skuIdAddSuccess]
        if (itemAdded !== undefined) itemAdded.loading = false
        state.length = (state.length && state.length + 1) || 1
      } else {
        if (itemAdded !== undefined) {
          delete state.groupedWishlistBySkuId[skuIdAddSuccess]
        }
      }
      state.loadingAddListCart = false
      return { ...state }
    }
    case 'ADD_WISHLIST_FAIL': {
      state.loadingAddListCart = false
      return { ...state }
    }

    case 'REMOVE_WISHLIST': {
      state.groupedWishlistBySkuId[action.skuId] &&
        (state.groupedWishlistBySkuId[action.skuId].loading = true)

      return { ...state }
    }
    case 'REMOVE_WISHLIST_CARD': {
      state.groupedWishlistBySkuId[action.skuId] &&
        delete state.groupedWishlistBySkuId[action.skuId]

      return { ...state }
    }

    case 'REMOVE_WISHLIST_SUCCESS': {
      if (action.payload.data === true) {
        var skuIdRemoveSuccess =
          action.meta &&
          action.meta.previousAction &&
          action.meta.previousAction.skuId

        state.groupedWishlistBySkuId[skuIdRemoveSuccess] &&
          (state.groupedWishlistBySkuId[skuIdRemoveSuccess].removed = true) &&
          (state.groupedWishlistBySkuId[skuIdRemoveSuccess].loading = false)
      }
      return { ...state }
    }
    case 'REMOVE_WISHLIST_FAIL': {
      var skuIdRemoveFail =
        action.meta &&
        action.meta.previousAction &&
        action.meta.previousAction.skuId

      state.groupedWishlistBySkuId[skuIdRemoveFail] &&
        (state.groupedWishlistBySkuId[skuIdRemoveFail].loading = false) &&
        (state.groupedWishlistBySkuId[skuIdRemoveFail].removed = false)
      return { ...state }
    }

    case 'SELECT_WISHLIST': {
      var wishlistSelect = state.groupedWishlistBySkuId[action.skuId]
      if (wishlistSelect) wishlistSelect.selected = action.selected

      getVerifySelected(state)
      return { ...state }
    }

    case 'SELECT_ALL_WISHLIST': {
      for (var i in state.groupedWishlistBySkuId) {
        !state.groupedWishlistBySkuId[i].removed &&
          (state.groupedWishlistBySkuId[i].selected = action.selected)
      }
      state.allSelected = action.selected
      state.leastOneSelected = state.allSelected

      return { ...state }
    }

    case 'LOAD_ADD_CART_WISHLIST': {
      state.loadingAddListCart = true
      return { ...state }
    }

    case 'ADD_CART_SUCCESS': {
      if (state.groupedWishlistBySkuId[action.skuId]) {
        state.groupedWishlistBySkuId[action.skuId].loadingAddCart = false
        state.groupedWishlistBySkuId[action.skuId].addedCart = true
      }
      state.redirectCart = getRedirectCart(state)
      state.loadingAddListCart = !state.redirectCart
      return state
    }
    case 'ADD_CART_FAIL': {
      if (state.groupedWishlistBySkuId[action.skuId]) {
        state.groupedWishlistBySkuId[action.skuId].loadingAddCart = false
        state.groupedWishlistBySkuId[action.skuId].errorAddCart = true
      }
      state.redirectCart = getRedirectCart(state)
      state.loadingAddListCart = !state.redirectCart
      return state
    }
    case 'ADD_WISHLIST_CART_FAIL': {
      return {
        ...state,
        hasMoreItems: false,
        error:
          action.request && action.request.status !== 404 ? 'Error' : undefined
      }
    }
    case 'ADD_CART_DONE': {
      return {
        ...state,
        loadingAddListCart: false,
        redirectCart: false
      }
    }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/reducer.js